export default "__VITE_ASSET__CQMjJMYb__"